/**
 * Componenet that display a list of AuthorisationItem
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

// Library
import { UseQueryResult } from '@tanstack/react-query';
import { Pagination, Skeleton } from '@components';
import { AuthorisationSummary, Page } from '@types';

// Types
import { AuthorisationItem } from '../authorisationItem/AuthorisationItem';

// Styles
import styles from './authorisationsList.module.scss';

/**
 * Props for AuthorisationsList
 */
export interface AuthorisationItemsListProps {
	/** Query hook to fetch the page of authorisations */
	getAuthorisations: UseQueryResult<Page<AuthorisationSummary> | undefined, Error>;
	/** Callback function to change the page */
	onPageChange: (page: number) => void;
	/** Callback function to report an issue */
	onItemClick: (meter: AuthorisationSummary, ind: number) => void;
	/** Index for indicating which authorisation in the array is selected */
	selectedIndexId: number;
}

export const AuthorisationsList = ({
	getAuthorisations,
	onPageChange,
	onItemClick,
	selectedIndexId,
}: AuthorisationItemsListProps) => {
	return (
		<div className={styles.listWrapper}>
			<div className={styles.wrapper} data-testid="authorisationsList">
				{getAuthorisations.isLoading || getAuthorisations.isFetching
					? Array.from(Array(3)).map((_el, id) => (
							<Skeleton key={id} customStyles={styles['skeleton-item']} />
						))
					: getAuthorisations.data?.items.map((auth, ind) => (
							<AuthorisationItem
								auth={auth}
								onItemClick={item => onItemClick(item, ind)}
								selected={selectedIndexId === ind}
								key={`${auth.id}-${ind}`}
							/>
						))}
			</div>
			<Pagination
				itemCounts={getAuthorisations.data?.metadata.totalCount ?? 0}
				paginationLimit={getAuthorisations.data?.metadata.limit ?? 0}
				handleClick={onPageChange}
			/>
		</div>
	);
};
